<template>
  <div class="home">
    <!-- <nav class="nav sticky top-0 bg-primary color-dark"> -->
    <nav
      class="nav py-2 px-4 fixed top-0 right-0 left-0 color-dark bg-white shadow"
    >
      <div class="container xl:max-w-screen-lg mx-auto">
        <div class="w-full flex flex-wrap items-center justify-between">
          <a class="" href="">
            <img src="../assets/logos/n.png" alt="" class="logo w-28 md:w-44" />
          </a>
          <ul class="nav-ul flex items-center gap-4">
            <li class="nav-li">
              <a href="#landing" class="nav-links font-medium text-xl">Home</a>
            </li>
            <li class="nav-li">
              <a href="#about" class="nav-links font-medium text-xl">About</a>
            </li>
            <li class="nav-li">
              <a href="#projects" class="nav-links font-medium text-xl"
                >Projects</a
              >
            </li>
            <li class="nav-li">
              <a href="#contact" class="nav-links font-medium text-xl"
                >Contact</a
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <section id="landing" class="landing">
      <LandingSection></LandingSection>
    </section>
    <section id="projects" class="projects px-4">
      <div class="container xl:max-w-screen-lg mx-auto py-5">
        <div class="main">
          <div class="my-10">
            <h2 class="font-bold text-2xl md:text-3xl my-4">About Us</h2>
            <p class="">
              Claons is a full service architecture, planning and design firm in
              Nigeria. Since 2016, we have developed an extensive, loyal client
              base and a porfolio that includes the most impressive and
              noteworthy architecture in the country.
            </p>
            <p>We offer:</p>
            <ul
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-4 gap-4"
            >
              <li class="list-disc ml-6 text-lg">Proper planning</li>
              <li class="list-disc ml-6 text-lg">Presentation Drawing</li>
              <li class="list-disc ml-6 text-lg">3D Visualization</li>
              <li class="list-disc ml-6 text-lg">Project Management</li>
              <li class="list-disc ml-6 text-lg">Consultation</li>
              <li class="list-disc ml-6 text-lg">Structural Drawings</li>
              <li class="list-disc ml-6 text-lg">Mechanical Drawings</li>
              <li class="list-disc ml-6 text-lg">Architectural Drawings</li>
              <li class="list-disc ml-6 text-lg">Construction</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section id="projects" class="projects px-4">
      <div class="container xl:max-w-screen-lg mx-auto py-5">
        <div class="main">
          <div class="my-10">
            <h2 class="font-bold text-2xl md:text-3xl my-4">
              Residential Building Designs
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div class="w-full" v-for="(building, i) in buildings" :key="i">
                <div class="">
                  <!-- <ProjectCard :i="i" :building="building"></ProjectCard> -->
                  <ProjectCard :building="building"></ProjectCard>
                </div>
              </div>
            </div>
          </div>
          <div class="my-10">
            <h2 class="font-bold text-2xl md:text-3xl my-4">Commercial Building Designs</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div class="w-full" v-for="(building, i) in commercials" :key="i">
                <div class="">
                  <!-- <ProjectCard :i="i" :building="building"></ProjectCard> -->
                  <ProjectCard :building="building"></ProjectCard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="contact" class="contact bg-light px-4">
      <div class="container xl:max-w-screen-lg mx-auto py-10">
        <div class="main text-center text-xl font-medium text-white">
          <!-- <h2 class="font-bold text-2xl md:text-3xl my-4">Contact me on</h2> -->
          <p>For more information or inquires, you can reach us on:</p>
          <p>
            <a href="tel:+2348154871164">+234 815 487 1164</a> or  
            <a href="tel:+2349021212760">+234 902 121 2760</a>
          </p>
          <p>or</p>
          <p>
            Send us a mail via
            <a href="mailto:claonsdsgn@gmail.com">claonsdsgn@gmail.com</a>
          </p>
        </div>
      </div>
    </section>
    <footer class="px-4 bg-dark text-white">
      <div class="container xl:max-w-screen-lg mx-auto py-10">
        <div class="flex justify-center">
          <p class="text-xl text-center">Rights Reserved &copy; 2021</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// import buildings from "../../buildings.json"
import buildings from "../../residential.json";
import commercials from "../../commercial.json";
import ProjectCard from "../components/ProjectCard";
import LandingSection from "../components/LandingSection";
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  data() {
    return {
      images: [],
      buildings: [],
      commercials: [],
    };
  },
  components: {
    ProjectCard,
    LandingSection,
    // HelloWorld,
    // HlloWorld,
  },
  methods: {
    importAll(r) {
      r.keys().forEach((key) =>
        // console.log(key)
        this.images.push({ pathLong: r(key), pathShort: key })
      );
    },
  },
  created() {
    this.buildings = buildings;
    this.commercials = commercials;
    // console.log(this.buildings);
    // this.buildings.forEach((building) => {
    //   this.images.push(building.face);
    // });
  },
};
</script>
